document.addEventListener('DOMContentLoaded', function () {
  // Function to check for denominations and update visibility
  function updateCartItemVisibility() {
    document.querySelectorAll('.cart-item').forEach((cartItem) => {
      // Find all product option dt elements
      const optionTitles = cartItem.querySelectorAll('.product-option dt');
      let hasDenomination = false;

      // Check if any option is a denomination
      optionTitles.forEach((dt) => {
        if (dt.textContent.toLowerCase().includes('denomination')) {
          hasDenomination = true;
        }
      });

      // Toggle the has-denomination class
      cartItem.classList.toggle('has-denomination', hasDenomination);

      // Handle elements that should be hidden when denomination exists
      if (hasDenomination) {
        // Hide these elements
        cartItem
          .querySelectorAll('.product-option, .edit__cart, .wish__cart, .gift__wrapping')
          .forEach((el) => (el.style.display = 'none'));
        // Show the change link
      } else {
        // Show these elements
        cartItem
          .querySelectorAll('.product-option, .edit__cart, .wish__cart, .gift__wrapping')
          .forEach((el) => (el.style.display = 'flex'));
        // Hide the change link
      }
    });
  }

  // Initial check when page loads
  updateCartItemVisibility();

  // Set up mutation observer to watch for changes in the cart items
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'childList' || mutation.type === 'subtree') {
        updateCartItemVisibility();
      }
    });
  });

  // Observe the cart items container
  const cartItemsContainer = document.querySelector('.cart__items');
  if (cartItemsContainer) {
    observer.observe(cartItemsContainer, {
      childList: true,
      subtree: true,
      attributes: false,
      characterData: false,
    });
  }

  // Also update when quantity changes (in case items are updated)
  document.addEventListener('change', function (e) {
    if (e.target.closest('.quantity__input')) {
      // Use setTimeout to allow cart to update before checking
      setTimeout(updateCartItemVisibility, 300);
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const giftWrapData = JSON.parse(localStorage.getItem('giftWrapData')) || {};
  let currentSection = null;

  function updateCartNoteFromLocalStorage() {
    const messages = Object.entries(giftWrapData)
      .map(([key, val], index) => {
        return `${index + 1}. ${val.title} Gift Wrapping\nMessage: ${val.message}`;
      })
      .join('\n\n');

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: messages }),
    });
  }

  // On page load, update UI
  document.querySelectorAll('.gift-wrap-section').forEach((section) => {
    const key = section.dataset.key;
    const status = section.querySelector('.gift-wrap-status');

    if (giftWrapData[key]) {
      section.querySelector('.wrapping-heading').style.display = 'none';
      status.style.display = 'block';
      status.textContent = 'Gift Wrapping added';
    }
  });

  // Open modal on button click
  document.querySelectorAll('.open-gift-wrap-modal').forEach((button) => {
    button.addEventListener('click', function () {
      currentSection = this.closest('.gift-wrap-section');
      document.getElementById('giftWrapModal').style.display = 'flex';
      document.getElementById('giftMessageInput').value = '';
      const checkoutBtn = document.querySelector('#checkout.cart__checkout-button');
      checkoutBtn.style.zIndex = '-1';
      document.querySelector('body').classList.add('overflow-hidden-desktop');
      document.querySelector('.section-header.shopify-section-group-header-group').style.zIndex = '0';
    });
  });

  // Close modal
  document.getElementById('closeGiftWrapModal').addEventListener('click', function () {
    document.getElementById('giftWrapModal').style.display = 'none';
    document.querySelector('#checkout.cart__checkout-button').style.zIndex = '';
    document.querySelector('body').classList.remove('overflow-hidden-desktop');
    document.querySelector('.section-header.shopify-section-group-header-group').style.zIndex = '3';
  });

  // Submit modal
  document.getElementById('submitGiftWrapModal').addEventListener('click', function () {
    const message = document.getElementById('giftMessageInput').value.trim();
    if (!message) {
      alert('Please enter a gift message.');
      return;
    }

    const key = currentSection.dataset.key;
    const title = currentSection.dataset.title;
    const status = currentSection.querySelector('.gift-wrap-status');
    const openButton = currentSection.querySelector('.wrapping-heading');
    const checkoutBtn = document.querySelector('#checkout.cart__checkout-button');

    // Save
    giftWrapData[key] = { title, message };
    localStorage.setItem('giftWrapData', JSON.stringify(giftWrapData));
    updateCartNoteFromLocalStorage();

    // Update UI
    openButton.style.display = 'none';
    status.style.display = 'block';
    status.textContent = 'Gift Wrapping added';
    checkoutBtn.style.zIndex = '';
    document.querySelector('body').classList.remove('overflow-hidden-desktop');
    document.querySelector('.section-header.shopify-section-group-header-group').style.zIndex = '3';

    // Close modal
    document.getElementById('giftWrapModal').style.display = 'none';
  });
});
